const videoProduction = {
  slug: "video-production",
  title: "Video Production at HintonX",
  category: "Video Production",
  client: "HintonX / Selected Clients",
  duration: "Ongoing",
  date: "2019 — Present",
  cover: "/assets/video-production-cover.jpg",
  gallery: [],
  summary: "Documentary, brand, sports, public-sector and product films. I shoot, edit, mix and deliver them.",
  blocks: [
    {
      type: "richText",
      html: `
        <p><strong>At HintonX, I lead end-to-end video production for clients across Ottawa and beyond—from Adobe and public-sector organizations to sports brands, athletes, and publishers.</strong></p>
        <p>My work spans promotional films, brand storytelling, interviews, event coverage, and full-length documentaries focused on memorable sports personalities and moments. I bring filming, photography, editing, sound engineering, and final production together into polished pieces designed to hold attention and leave a lasting impression.</p>
      `,
    },
    {
      type: "youtube",
      id: "iUXu4dyxbSI",
      title: "The Legend",
      description: "Opening Sequence Teaser for the Upcoming Documentary",
      number: "01",
    },
    {
      type: "youtube",
      id: "hYZgGD9qSzY",
      title: "Creativity in Public Sector",
      description: "Client Adobe",
      number: "02",
    },
    {
      type: "youtube",
      id: "Kjk2cX7xaNU",
      title: "The 2024 Tennis Season",
      description: "fficial Book Trailer",
      number: "03",
    },
    {
      type: "youtube",
      id: "qzKlpU0CvGM",
      title: "Adobe and Service Canada",
      description: "Promo Video",
      number: "04",
    },
    {
      type: "youtube",
      id: "3mxLcNnxfNU",
      title: "Novak Djokovic",
      description: "Year End #1 Yearbook Collection",
      number: "05",
    },
    {
      type: "youtube",
      id: "5OH6sWLEL8c",
      title: "ToldYa",
      description: "Mobile App Promo",
      number: "06",
    },
    {
      type: "youtube",
      id: "bmYRh4Yy1nk",
      title: "100 Mobile",
      description: "Message App Promo",
      number: "07",
    },
  ],
  liveUrl: "https://www.hintonx.com/matiadosen",
  relatedSlugs: ["2024-chasing-greatness", "novak-books", "toldya-tennis"],
  seo: {
    title: "Video Production at HintonX — Matia Dosen",
    description: "Selected documentary, brand, sports, public-sector, and product video production by Matia Dosen.",
  },
}

export default videoProduction
